axboot.getJSON = function(v) {
  if (v) {
    return v;
  } else {
    return {};
  }
};
